import { debounce } from '../helpers';

/* Make Hero Pattern height to be exactly 100vh by default */
function adjustHeroHeight() {
	if ( window.matchMedia( '(max-width: 782px)' ).matches || ! document.querySelector( '.homepage-hero-pattern' ) ) {
		return;
	}

	if ( document.querySelector( '.homepage-hero-pattern > .wp-block-cover' ).style.minHeight !== '100vh' ) {
		return;
	}
	const headerHeight = document.getElementById( 'masthead' ) ? document.getElementById( 'masthead' ).offsetHeight : 0;
	const adminBarHeight = document.getElementById( 'wpadminbar' ) ? document.getElementById( 'wpadminbar' ).offsetHeight : 0;
	const offset = headerHeight + adminBarHeight;
	document.querySelector( '.homepage-hero-pattern > .wp-block-cover' ).style.minHeight = 'calc(100vh -' + ' ' + offset + 'px' + ')';
}
/* Remove dynamic caching for the hero pattern to keep the animation */
function addTimeStampToBlocksImage() {
	const image = document.querySelector( '.homepage-hero-pattern .wp-block-columns img' );
	if ( image ) {
		image.src = image.src + '?ver=' + Date.now();
	}
}
export function heroPattern() {
	adjustHeroHeight();
	window.addEventListener( 'resize', debounce( adjustHeroHeight, 50 ) );
	window.addEventListener( 'load', addTimeStampToBlocksImage );
}
